
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import { useGetTimberTypeQuery, useGetTimberTypeListQuery, useGetTimberTypePresentationQuery } from "../../../../timber/apis/TimberType.api";
import { TimberTypeNameDisplay, default as TimberTypeName } from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import { toString as toStringTimberType, PrimaryTimberType } from "../../../../timber/types/models/TimberType";

import { useGetTimberClassQuery, useGetTimberClassListQuery, useGetTimberClassPresentationQuery } from "../../../../timber/apis/TimberClass.api";
import { TimberClassNameDisplay, default as TimberClassName } from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import { toString as toStringTimberClass, PrimaryTimberClass } from "../../../../timber/types/models/TimberClass";

import { useGetThicknessClassQuery, useGetThicknessClassListQuery, useGetThicknessClassPresentationQuery } from "../../../../timber/apis/ThicknessClass.api";
import { ThicknessClassNameDisplay, default as ThicknessClassName } from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import { toString as toStringThicknessClass, PrimaryThicknessClass } from "../../../../timber/types/models/ThicknessClass";
import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import ManageSearch from "@mui/icons-material/ManageSearch";
import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";




export const initialFormStateFn = () => { return {
    
    
    
    
} }

export const formObject = {
    
        timberTypeId: string()
            .nullish(),
        
        
    
        classId: string()
            .nullish(),
        
        
    
        thicknessClassId: string()
            .nullish(),
        
        
        thicknessClassIdInclude: boolean().default(false),
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;



type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const PriceListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('Price')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const { data: timberTypeList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberTypeListLoading,
        isFetching: getTimberTypeListFetching, 
    } = useGetTimberTypeListQuery()
    
    
    const { data: timberClassList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberClassListLoading,
        isFetching: getTimberClassListFetching, 
    } = useGetTimberClassListQuery()
    
    
    const { data: thicknessClassList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getThicknessClassListLoading,
        isFetching: getThicknessClassListFetching, 
    } = useGetThicknessClassListQuery()
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const thicknessClassIdInclude = watch(prefix + 'thicknessClassIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="Price-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Timber Type, Timber Class, Thickness Class)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="Price-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'timberTypeId' }
                optionsLoading={ getTimberTypeListLoading || getTimberTypeListFetching }
                label={t`Timber Type`}
                options={ timberTypeList.items }
                valueMap={ (id) => useGetTimberTypeQuery(PrimaryTimberType.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberType }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberTypeNameDisplay data={option}/></li>)
                } }
                
                
        />
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'classId' }
                optionsLoading={ getTimberClassListLoading || getTimberClassListFetching }
                label={t`Timber Class`}
                options={ timberClassList.items }
                valueMap={ (id) => useGetTimberClassQuery(PrimaryTimberClass.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberClass }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberClassNameDisplay data={option}/></li>)
                } }
                
                
        />
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'thicknessClassId' }
                optionsLoading={ getThicknessClassListLoading || getThicknessClassListFetching }
                label={t`Thickness Class`}
                options={ thicknessClassList.items }
                valueMap={ (id) => useGetThicknessClassQuery(PrimaryThicknessClass.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringThicknessClass }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><ThicknessClassNameDisplay data={option}/></li>)
                } }
                disabled={ !!thicknessClassIdInclude }
                
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'thicknessClassIdInclude' }
        icon={<AddCircleOutline />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default PriceListSearch;
